var _path, _path2, _path3, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComentarios(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 130,
    viewBox: "0 0 212 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6475 0C8.34843 0.000261676 0 8.34936 0 18.6484V54.6133C1.52588e-05 64.9125 8.3492 73.2617 18.6484 73.2617H79.2266C81.7057 73.8666 84.3145 75.4882 84.3145 79.5889V94.2412C84.3145 100.901 91.9051 104.564 96.6357 97.5713C102.763 88.5135 107.847 81.8089 109.623 79.5889C110.458 77.7341 113.571 74.3317 119.854 73.2617H121.88C123.283 73.2617 124.651 73.1054 125.966 72.8115C130.047 72.3252 132.829 70.388 134.625 68.2256C138.258 64.8229 140.528 59.9836 140.528 54.6133V18.6484C140.528 8.3492 132.179 0 121.88 0H18.6475Z",
    fill: "#595BFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9805 33.266L23.615 40.158C25.1988 43.1613 29.5694 42.9461 30.8505 39.8017L34.5906 30.6217C35.9786 27.2149 40.8432 27.3347 42.0618 30.8056L46.6029 43.7397C47.8325 47.2421 52.7567 47.3218 54.099 43.861L56.6837 37.1973C57.9162 34.0196 62.3055 33.7444 63.9253 36.7432L66.3098 41.1578C68.0714 44.4192 72.9389 43.7327 73.7298 40.1114L77.1666 24.3756C78.0908 20.144 84.1452 20.2007 84.99 24.4488L89.8389 48.8319C90.6473 52.8968 96.3464 53.1952 97.5748 49.2369L103.036 31.6389C104.277 27.6418 110.048 27.9988 110.786 32.1183L111.832 37.954C112.467 41.4987 117.099 42.4604 119.093 39.4616L123.213 33.266",
    stroke: "#BFBFFF",
    strokeWidth: 2.66406,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.352 28.2759C203.651 28.2759 212 36.6251 212 46.9243V82.8892C212 93.1884 203.651 101.538 193.352 101.538H189.266C182.98 102.607 179.867 106.01 179.032 107.865C177.256 110.085 172.172 116.789 166.045 125.847C161.314 132.84 153.724 129.177 153.724 122.517V107.865C153.724 103.764 151.115 102.142 148.636 101.538H138.072C136.869 101.538 135.693 101.422 134.553 101.205H134.409L134.414 101.177C125.867 99.477 119.424 91.9362 119.424 82.8892V46.9243C119.424 36.6251 127.773 28.2759 138.072 28.2759H193.352Z",
    fill: "#BFBFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.66015,
    cy: 6.66015,
    r: 6.66015,
    transform: "matrix(-1 0 0 1 191.353 57.5806)",
    fill: "#2F32FE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.66015,
    cy: 6.66015,
    r: 6.66015,
    transform: "matrix(-1 0 0 1 172.705 57.5808)",
    fill: "#2F32FE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.66015,
    cy: 6.66015,
    r: 6.66015,
    transform: "matrix(-1 0 0 1 154.056 57.5808)",
    fill: "#2F32FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComentarios);
export default __webpack_public_path__ + "static/media/comentarios.87737a61.svg";
export { ForwardRef as ReactComponent };